export default __webpack_public_path__ + "static/media/beeple.9871ca40.jpg";